
import {hashHistory} from 'react-router'

import {toQueryObject} from '../utils/queryObjectMapper'

const applyQueryToUrl = (query) => {
  const path = location.hash.replace("#", '').replace(/\?.*/, '')
  hashHistory.push({pathname: path, query:toQueryObject(query)}); 
}  
export default applyQueryToUrl



/** WEBPACK FOOTER **
 ** ./app/utils/applyQueryToUrl.js
 **/